import { formatNumber } from "utils";

import { FieldListField, FieldPracticeResponse } from "models";

import type { FieldStatus } from "pages/app/all-field-view/hooks/useFieldStatusMap";

export type HomeFieldStats = {
  fieldCount: number;
  totalHectares: number;
  cropCount: number;
  enrolledCount: number;
  enrolledHectares: number;
  completeCount: number;
};

const roundHectares = (hectares: number) => Math.round(hectares * 10) / 10;

/** "24.9" for fractions, "20" for whole hectares (never "20.0") */
export const formatHectares = (hectares: number): string => formatNumber({ number: hectares, decimalPlaces: Number.isInteger(hectares) ? 0 : 1 });

export const summariseFieldStats = (
  fields: FieldListField[],
  fieldStatusMap: Record<string, FieldStatus>,
  fieldPractices: Record<string, FieldPracticeResponse> | undefined,
  cropYear: number,
  // programs that enrol every field automatically (inventory), counted like the fields page does
  { allFieldsEnrolled = false }: { allFieldsEnrolled?: boolean } = {}
): HomeFieldStats => {
  const enrolledFields = allFieldsEnrolled ? fields : fields.filter((field) => fieldStatusMap[field.id]?.enrolled);
  const cropIdsOfYear = new Set(
    Object.values(fieldPractices ?? {}).flatMap((fieldPractice) => fieldPractice.crops.filter((crop) => crop.year === cropYear).map((crop) => crop.cropId))
  );

  return {
    fieldCount: fields.length,
    totalHectares: roundHectares(fields.reduce((sum, field) => sum + (field.size ?? 0), 0)),
    cropCount: cropIdsOfYear.size,
    enrolledCount: enrolledFields.length,
    enrolledHectares: roundHectares(enrolledFields.reduce((sum, field) => sum + (field.size ?? 0), 0)),
    completeCount: enrolledFields.filter((field) => fieldStatusMap[field.id]?.isComplete).length,
  };
};
